















import Vue from "vue";
import { DateTime, Info } from "luxon";

export default Vue.extend({
    name: "InfolandDatePicker",
    inheritAttrs: false,
    props: {
        /** What is the max allowed date? */
        maxValue: { type: Date, default: () => new Date(9999, 11, 31), required: false },
        /** What is the min allowed date?  */
        minValue: { type: Date, default: () => new Date(1753, 0, 1), required: false },
        /** Should the current date be shown? */
        showCurrent: { type: Boolean, default: false, required: false }
    },
    data() {
        return {};
    },
    computed: {
        /** Returns the ISO string of the max allowed date */
        maxDateAllowed(): string {
            // use luxon to only pass the date not the time,
            //to prevent dates to go from 2022-12-07T00:00:00 to 2022-12-06T23:00:00
            return DateTime.fromJSDate(this.maxValue as Date).toISODate();
        },
        /** Returns the ISO string of the min allowed date */
        minDateAllowed(): string {
            // use luxon to only pass the date not the time,
            //to prevent dates to go from 2022-12-07T00:00:00 to 2022-12-06T23:00:00
            return DateTime.fromJSDate(this.minValue as Date).toISODate();
        },
        /** Returns the language prop if that is set, otherwise return 'nl-NL' */
        locale(): string {
            // Assume this.$user.language is available in your context
            return this.$user?.language ? this.$user.language : "nl-NL";
        },
        firstDayOfWeek(): number {
            // from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/weekData/firstDay
            var firstDay = {
                /*default is 1=Monday*/
                bd: 5,
                mv: 5,
                ae: 6,
                af: 6,
                bh: 6,
                dj: 6,
                dz: 6,
                eg: 6,
                iq: 6,
                ir: 6,
                jo: 6,
                kw: 6,
                ly: 6,
                ma: 6,
                om: 6,
                qa: 6,
                sa: 6,
                sd: 6,
                sy: 6,
                ye: 6,
                ag: 0,
                ar: 0,
                as: 0,
                au: 0,
                br: 0,
                bs: 0,
                bt: 0,
                bw: 0,
                by: 0,
                bz: 0,
                ca: 0,
                cn: 0,
                co: 0,
                dm: 0,
                do: 0,
                et: 0,
                gt: 0,
                gu: 0,
                hk: 0,
                hn: 0,
                id: 0,
                ie: 0,
                il: 0,
                in: 0,
                jm: 0,
                jp: 0,
                ke: 0,
                kh: 0,
                kr: 0,
                la: 0,
                mh: 0,
                mm: 0,
                mo: 0,
                mt: 0,
                mx: 0,
                mz: 0,
                ni: 0,
                np: 0,
                nz: 0,
                pa: 0,
                pe: 0,
                ph: 0,
                pk: 0,
                pr: 0,
                py: 0,
                sg: 0,
                sv: 0,
                th: 0,
                tn: 0,
                tt: 0,
                tw: 0,
                um: 0,
                us: 0,
                ve: 0,
                vi: 0,
                ws: 0,
                za: 0,
                zw: 0
            };

            var country = (country = this.locale.split("-")[1].toLowerCase());
            var dow = firstDay[country];
            return dow === undefined ? 1 : dow; /*Number*/
        }
    },
    methods: {}
});
